import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ComingSoonPage } from '@eruvaka/web-pondlogs-base';
export const Dashboard = memo(() => _jsx(ComingSoonPage, {}));
